module.exports = __webpack_public_path__ + "static/media/Arbeidminne-Na-kommer-det-flere-tal.03c17429.mp3";